import type { ClassicTrade } from 'state/routing/types'
import { isKibaRouterBuildEnabled } from 'utils/robinhoodRouter/flags'

/** Router (Permit2) spender precedence: first-party Robinhood router > Kyber router > Universal Router. */
export function selectSwapSpender(opts: {
  robinhoodRouterSpender?: string
  kyberRouterAddress?: string
  universalRouterFallback?: string
}): string | undefined {
  return opts.robinhoodRouterSpender ?? opts.kyberRouterAddress ?? opts.universalRouterFallback
}

// The router's Permit2 spender is its Universal Router (approval.permit2Spender is this).
export const ROBINHOOD_ROUTER_UR_SPENDER = '0x8876789976dEcBfCbBbe364623C63652db8C0904'

/**
 * Read-only gating: a Robinhood router trade is visible for quotes at all times, but is only
 * executable (swap button enabled) once the build flag is on. Non-router trades are unaffected.
 */
export function isRouterSwapExecutable(trade: Pick<ClassicTrade, 'robinhoodRouterData'>): boolean {
  if (!trade.robinhoodRouterData) return true
  return isKibaRouterBuildEnabled()
}
